<template>
    <b-tab :title="langTabTitle" active>
        <b-form-group>
            <b-row>
                <b-form-group class="col-md-6" label-for="form_edit_name">
                    <template v-slot:label>
                        <span key="lang_form_edit_name">Playlist Name</span>
                    </template>
                    <b-form-input id="form_edit_name" type="text" v-model="form.name.$model"
                                  :state="form.name.$dirty ? !form.name.$error : null"></b-form-input>
                    <b-form-invalid-feedback>
                        <span key="lang_error_required">This field is required.</span>
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group class="col-md-6" label-for="form_edit_weight">
                    <template v-slot:label>
                        <span key="lang_form_edit_weight">Playlist Weight</span>
                    </template>
                    <template v-slot:description>
                        <span key="lang_form_edit_weight_desc">Higher weight playlists are played more frequently compared to other lower-weight playlists.</span>
                    </template>
                    <b-form-select id="form_edit_weight" v-model="form.weight.$model" :options="weightOptions"
                                   :state="form.weight.$dirty ? !form.weight.$error : null"></b-form-select>
                    <b-form-invalid-feedback>
                        <span key="lang_error_required">This field is required.</span>
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group class="col-md-6" label-for="form_edit_is_enabled">
                    <template v-slot:description>
                        <span key="lang_form_edit_is_enabled_desc">If disabled, the playlist will not be included in radio playback, but can still be managed.</span>
                    </template>
                    <b-form-checkbox id="form_edit_is_enabled" v-model="form.is_enabled.$model">
                        <span key="lang_form_edit_is_enabled">Is Enabled</span>
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group class="col-md-6" label-for="form_edit_avoid_duplicates">
                    <template v-slot:description>
                        <span key="lang_form_edit_avoid_duplicates_desc">Whether the AutoDJ should attempt to avoid duplicate artists and track titles when playing media from this playlist.</span>
                    </template>
                    <b-form-checkbox id="form_edit_avoid_duplicates" v-model="form.avoid_duplicates.$model">
                        <span key="lang_form_edit_avoid_duplicates">Avoid Duplicate Artists/Titles</span>
                    </b-form-checkbox>
                </b-form-group>

                <!-- <b-form-group class="col-md-12" label-for="form_edit_include_in_on_demand">
                    <template v-slot:description>
                        <span key="lang_form_edit_include_in_on_demand_desc">If this station has on-demand streaming and downloading enabled, only songs that are in playlists with this setting enabled will be visible.</span>
                    </template>
                    <b-form-checkbox id="form_edit_include_in_on_demand" v-model="form.include_in_on_demand.$model">
                        <span key="lang_form_edit_include_in_on_demand">Include in On-Demand Player</span>
                    </b-form-checkbox>
                </b-form-group> -->

                <b-form-group class="col-md-12" label-for="edit_form_type">
                    <template v-slot:label>
                        <span key="lang_edit_form_type">Playlist Type</span>
                    </template>
                    <b-form-radio-group stacked id="edit_form_type" v-model="form.type.$model">
                        <b-form-radio value="default">
                            <span key="lang_form_type_default">General Rotation</span>
                            <small class="form-text mt-0" key="lang_form_type_default_desc">Standard playlist, shuffles with other standard playlists based on weight.</small>
                        </b-form-radio>
                        <b-form-radio value="once_per_x_tracks">
                            <span key="lang_form_type_once_per_x_tracks">Once per x Songs</span>
                            <small class="form-text mt-0" key="lang_form_type_once_per_x_tracks_desc">Play exactly once every $x songs.</small>
                        </b-form-radio>
                        <b-form-radio value="once_per_x_minutes">
                            <span key="lang_form_type_once_per_x_minutes">Once per x Minutes</span>
                            <small class="form-text mt-0" key="lang_form_type_once_per_x_minutes_desc">Play exactly once every $x minutes.</small>
                        </b-form-radio>
                        <b-form-radio value="once_per_hour">
                            <span key="lang_form_type_once_per_hour">Once per Hour</span>
                            <small class="form-text mt-0" key="lang_form_type_once_per_hour_desc">Play once per hour at the specified minute.</small>
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </b-row>
        </b-form-group>

        <!-- <b-card v-show="form.type.$model === 'default'" class="mb-3" no-body>
            <div class="card-header bg-primary-dark">
                <h2 class="card-title">
                    <span key="lang_type_default">General Rotation</span>
                </h2>
            </div>
            <b-card-body>
                <b-form-group>
                    <b-row>
                        <b-form-group class="col-md-6" label-for="form_edit_include_in_automation">
                            <template v-slot:description>
                                <span key="lang_form_edit_include_in_automation_desc">If auto-assignment is enabled, use this playlist as one of the targets for songs to be redistributed into. This will overwrite the existing contents of this playlist.</span>
                            </template>
                            <b-form-checkbox id="form_edit_include_in_automation" v-model="form.include_in_automation.$model">
                                <span key="lang_form_edit_include_in_automation">Include in Automated Assignment</span>
                            </b-form-checkbox>
                        </b-form-group>
                    </b-row>
                </b-form-group>
            </b-card-body>
        </b-card> -->

        <b-card v-show="form.type.$model === 'once_per_x_tracks'" class="mb-3" no-body>
            <div class="card-header bg-primary-dark">
                <h2 class="card-title">
                    <span key="lang_type_once_per_x_tracks">Once per x Songs</span>
                </h2>
            </div>
            <b-card-body>
                <b-form-group>
                    <b-row>
                        <b-form-group class="col-md-6" label-for="form_edit_play_per_tracks">
                            <template v-slot:label>
                                <span key="lang_form_edit_play_per_tracks">Number of Songs Between Plays</span>
                            </template>
                            <template v-slot:description>
                                <span key="lang_form_edit_play_per_tracks_desc">This playlist will play every $x songs, where $x is specified here.</span>
                            </template>
                            <b-form-input id="form_edit_play_per_tracks" type="number" min="0" max="150"
                                          v-model="form.play_per_tracks.$model"
                                          :state="form.play_per_tracks.$dirty ? !form.play_per_tracks.$error : null"></b-form-input>
                            <b-form-invalid-feedback>
                                <span key="lang_error_required">This field is required.</span>
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-row>
                </b-form-group>
            </b-card-body>
        </b-card>

        <b-card v-show="form.type.$model === 'once_per_x_minutes'" class="mb-3" no-body>
            <div class="card-header bg-primary-dark">
                <h2 class="card-title">
                    <span key="lang_form_type_once_per_x_minutes">Once per x Minutes</span>
                </h2>
            </div>
            <b-card-body>
                <b-form-group>
                    <b-row>

                        <b-form-group class="col-md-6" label-for="form_edit_play_per_minutes">
                            <template v-slot:label>
                                <span key="form_edit_play_per_minutes">Number of Minutes Between Plays</span>
                            </template>
                            <template v-slot:description>
                                <span key="form_edit_play_per_minutes_desc">This playlist will play every $x minutes, where $x is specified here.</span>
                            </template>
                            <b-form-input id="form_edit_play_per_minutes" type="number" min="0" max="360"
                                          v-model="form.play_per_minutes.$model"
                                          :state="form.play_per_minutes.$dirty ? !form.play_per_minutes.$error : null"></b-form-input>
                            <b-form-invalid-feedback>
                                <span key="lang_error_required">This field is required.</span>
                            </b-form-invalid-feedback>
                        </b-form-group>

                    </b-row>
                </b-form-group>
            </b-card-body>
        </b-card>

        <b-card v-show="form.type.$model === 'once_per_hour'" class="mb-3" no-body>
            <div class="card-header bg-primary-dark">
                <h2 class="card-title">
                    <span key="lang_type_once_per_hour">Once per Hour</span>
                </h2>
            </div>
            <b-card-body>
                <b-form-group>
                    <b-row>

                        <b-form-group class="col-md-6" label-for="form_edit_play_per_hour_minute">
                            <template v-slot:label>
                                <span key="lang_form_edit_play_per_hour_minute">Minute of Hour to Play</span>
                            </template>
                            <template v-slot:description>
                                <span key="lang_form_edit_play_per_hour_minute_desc">Specify the minute of every hour that this playlist should play.</span>
                            </template>
                            <b-form-input id="form_edit_play_per_hour_minute" type="number" min="0" max="59"
                                          v-model="form.play_per_hour_minute.$model"
                                          :state="form.play_per_hour_minute.$dirty ? !form.play_per_hour_minute.$error : null"></b-form-input>
                            <b-form-invalid-feedback>
                                <span key="lang_error_required">This field is required.</span>
                            </b-form-invalid-feedback>
                        </b-form-group>

                    </b-row>
                </b-form-group>
            </b-card-body>
        </b-card>
    </b-tab>
</template>

<script>
export default {
    name: 'PlaylistEditBasicInfo',
    props: {
        form: Object
    },
    data () {
        let weightOptions = [
            { value: 1, text: '1 - ' + 'Low' },
            { value: 2, text: '2' },
            { value: 3, text: '3 - ' + 'Default' },
            { value: 4, text: '4' },
            { value: 5, text: '5 - ' + 'High' }
        ];
        for (var i = 6; i <= 10; i++) {
            weightOptions.push({ value: i, text: i });
        }

        return {
            weightOptions: weightOptions
        };
    },
    computed: {
        langTabTitle () {
            return 'Basic Info';
        }
    }
};
</script>
